module.exports = __webpack_public_path__ + "static/media/partner-icon.b675756a.png";